import { createContext, useContext, useState } from 'react';

import { useBoundStore } from 'app/store';

export const UserFormContext = createContext({
  invalidFields: {},
  setInvalidFields: () => {},
  addressData: {},
  setAddressData: () => {},
});

export const UserFormProvider = ({ children }) => {
  const { usrTelNo, postNo, bscAddr, dtlAddr, bldgCd, actualPostNo, actualBscAddr, actualDtlAddr, actualBldgCd } =
    useBoundStore((state) => state.hsptlzForm.patientInfoData);

  const [invalidFields, setInvalidFields] = useState({
    tel: usrTelNo?.split('|')?.map((v) => (v ? false : undefined)) || [],
  });

  const [addressData, setAddressData] = useState({
    addr: { bscAddr, dtlAddr, postNo, bldgCd },
    actualAddr: {
      bscAddr: actualBscAddr,
      dtlAddr: actualDtlAddr,
      postNo: actualPostNo,
      bldgCd: actualBldgCd,
      isSameAddr: false,
    },
  });
  return (
    <UserFormContext.Provider value={{ invalidFields, setInvalidFields, addressData, setAddressData }}>
      {children}
    </UserFormContext.Provider>
  );
};

export const useUserFormContext = () => {
  const context = useContext(UserFormContext);
  if (!context) {
    throw new Error('useFiledContext must be used within a UserFormProvider');
  }
  return context;
};
